import styled from "@emotion/styled";

export const ColumnFlexBox = styled.div(({ style }) => ({
  display: "flex",
  flexDirection: "column",
  ...style,
}));

export const RowFlexBox = styled.div(({ style }) => ({
  display: "flex",
  flexDirection: "row",
  ...style,
}));
